/**
 * @module Filters
 */

/**
 * @memberOf module:Filters
 *
 * Első betű nagybetűvé alaítása
 * @param {string} str
 * @returns {string}
 */
export function capitalize(inputValue) {
    /* if(!str) return ''
    str = str.toString()
    return str.charAt(0).toUpperCase() + str.slice(1) */
    let clonedInputValue = inputValue;

    if (clonedInputValue === undefined || clonedInputValue == null) { clonedInputValue = ''; }
    let capitalized = clonedInputValue.replace(
        /[a-zA-Z0-9_\u00E9\u00E1\u00ED\u0171\u0151\u00F6\u00FC\u00FA\u00F3]*\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
    );

    capitalized = capitalized.replace(
        /-./g,
        (txt) => txt.charAt(0) + txt.charAt(1).toUpperCase(),
    );

    return capitalized;
}

export function capitalizeAllCharacters(inputValue) {
    let clonedInputValue = inputValue;
    if (clonedInputValue === undefined || clonedInputValue == null) { clonedInputValue = ''; }
    const capitalized = clonedInputValue.replace(
        /[a-zA-Z0-9_\u00E9\u00E1\u00ED\u0171\u0151\u00F6\u00FC\u00FA\u00F3]*\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase(),
    );
    return capitalized;
}
